import apiService from './apiService';
import { EmailBatch } from '../store/slices/emailBatchSlice';

export const getBatches = async (): Promise<EmailBatch[]> => {
  const response = await apiService.get<EmailBatch[]>('/email-batches');
  return response.data;
};

export const getBatchById = async (id: string): Promise<EmailBatch> => {
  const response = await apiService.get<EmailBatch>(`/email-batches/${id}`);
  return response.data;
};

export const createBatch = async (batchData: Omit<EmailBatch, 'id' | 'status' | 'createdAt' | 'updatedAt'>): Promise<EmailBatch> => {
  const response = await apiService.post<EmailBatch>('/email-batches', batchData);
  return response.data;
};

export const updateBatch = async (id: string, batchData: Partial<EmailBatch>): Promise<EmailBatch> => {
  const response = await apiService.put<EmailBatch>(`/email-batches/${id}`, batchData);
  return response.data;
};

export const deleteBatch = async (id: string): Promise<void> => {
  await apiService.delete(`/email-batches/${id}`);
};

export const sendBatch = async (id: string): Promise<EmailBatch> => {
  const response = await apiService.post<EmailBatch>(`/email-batches/${id}/send`);
  return response.data;
};

export const getTemplates = async (): Promise<{ id: string; name: string; content: string }[]> => {
  const response = await apiService.get<{ id: string; name: string; content: string }[]>('/email-templates');
  return response.data;
}; 